<template>
  <div class="container-fluid p-3">
    <div class="mt-3">
      <div class="justify-content-between d-flex">
        <div class="d-flex">
          <b-form-input
            class="my-auto"
            v-model="searchFilter.message"
            placeholder="Message..."
            @keydown.enter="fetchLogs"
          ></b-form-input>
          <b-btn class="my-auto ml-2" variant="primary" @click="fetchLogs"
            >search</b-btn
          >
        </div>
        <div>
          <h2 class="my-auto">Log Entry List</h2>
        </div>
        <div class="d-flex">
          <span class="mr-2 mt-2">Treffer: {{ totalResults }}</span>
          <b-pagination
            class="mr-2"
            v-model="currentPage"
            :total-rows="totalResults"
            :per-page="100"
          ></b-pagination>
        </div>
      </div>
    </div>
    <div class="">
      <b-table :fields="fields" :items="logEntries" striped hover>
        <template #cell(level)="row">
          <span v-if="row.item.level > 4">{{
            getLogLevelName(row.item.level)
          }}</span>
          <span v-else-if="row.item.level == 4" style="color: orange">{{
            getLogLevelName(row.item.level)
          }}</span>
          <span v-else class="text-danger"
            ><b>{{ getLogLevelName(row.item.level) }}</b></span
          >
        </template>
      </b-table>
    </div>
  </div>
</template>
<script>
import { useOffsetQueryStore } from "../stores/OffsetQueryStore";

export default {
  setup() {
    const offsetQueryStore = useOffsetQueryStore();
    return {
      logEntryQuery: offsetQueryStore.logEntryQuery,
    };
  },
  data() {
    return {
      fields: [
        { key: "level", label: "Level" },
        { key: "logTime", label: "logTime" },
        { key: "message", label: "Message" },
        { key: "nodeName", label: "NodeName" },
        { key: "logGroup", label: "logGroup" },
      ],
      logEntries: [],
      totalResults: 0,
      offset: 0,
      queryInProgress: false,
      currentPage: 1,
      searchFilter: {
        offset: 0,
        limit: 100,
        message: "",
      },
    };
  },
  methods: {
    fetchLogs() {
      this.queryInProgress = true;
      return this.logEntryQuery(this.searchFilter)
        .then((storeResponse) => {
          console.log(storeResponse);
          this.logEntries = storeResponse[0];
          this.totalResults = storeResponse[1];
          this.queryInProgress = false;
        })
        .catch((err) => {
          console.log(err);
          this.queryInProgress = false;
        });
    },
    getLogLevelName(level) {
      const logLevels = [
        { logLevel: 0, logLevelName: "Emergency" },
        { logLevel: 1, logLevelName: "Alert" },
        { logLevel: 2, logLevelName: "Critical" },
        { logLevel: 3, logLevelName: "Error" },
        { logLevel: 4, logLevelName: "Warning" },
        { logLevel: 5, logLevelName: "Notice" },
        { logLevel: 6, logLevelName: "Info" },
        { logLevel: 7, logLevelName: "Debug" },
      ];
      return logLevels.find((element) => element.logLevel === level)
        .logLevelName;
    },
  },
  watch: {
    currentPage() {
      this.searchFilter.offset = (this.currentPage - 1) * 100;
      if (this.queryInProgress === false) {
        this.fetchLogs();
      }
    },
  },
  created() {
    this.fetchLogs();
  },
};
</script>
